import React, { useState } from 'react';
import { View, Picker } from 'react-native';
import { useQuery } from '@apollo/client';
import styled from 'styled-components/native';

import DataState from 'app/src/components/DataState';
import {
  MainContainer,
  ContentContainer,
  PageTitle,
  TabButtonContainer,
  TabButton,
} from 'app/src/elements';
import { StyledPicker } from 'app/src/elements/inputs';
import { Text } from 'app/src/styles';
import { elLightGray, elRed } from 'app/src/styles/colors';
import { useParams, useNavigate } from 'app/src/utils/routing';
import { plural } from 'app/src/utils/stringHelpers';

import Active from './Active';
import Lots from './Lots';
import Registered from './Registered';
// import SaleRegistered from './SaleRegistered';
import { SALE_BUYERS } from './queries';

const TabLabel = styled(Text)`
  font-weight: 900;
`;

const Settings = styled(View)`
  flex-direction: row;
  margin-top: 10px;
  margin-bottom: 20px;
  gap: 20px;
  align-items: baseline;
`;

const labelStyle = (currentTab, tab) => (
  { color: currentTab === tab ? 'white' : 'black' }
);

const tabStyle = (currentTab, tab) => (
  {
    backgroundColor: currentTab === tab ? elRed : elLightGray,
    width: 'auto',
  }
);

export const USER_SCOPES = [
  { label: 'Registered for Sale', value: 'sale_registered'},
  { label: 'Registered', value: 'registered' },
  { label: 'Has Joined Auction', value: 'joined' },
  { label: 'Has Bid in this sale', value: 'bid' },
  { label: 'Has Bought in this sale', value: 'buyer' },
  { label: 'Logged in prior 2 weeks', value: 'logged_in' },
  { label: 'Looked at any Asset in sale', value: 'asset' },
  { label: 'Looked at sale lots screen', value: 'sale' },
];

const BiddingBuyers = ({ sale }) => {
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState('Active')
  const [scope, setScope] = useState('sale_registered');

  const { id } = useParams();
  const { data } = useQuery(SALE_BUYERS, {
    variables: { id: (id || sale.id), scope },
    fetchPolicy: 'network-only',
  });

  if (!data) { return <DataState.Loading />; }

  const changeSale = value => {
    if (value) {
      navigate(`/bidding/buyers/${value}`);
    }
  };

  const registeredLabel = USER_SCOPES.find(({ value }) => value === scope).
    label;

  return (
    <MainContainer style={{minWidth: '60vw', minHeight: '60vh'}}>
      <ContentContainer>
        {!sale && (
          <>
            <PageTitle>{data.sale.name}</PageTitle>
            <Settings>
              <Text>Change Sale:</Text>
              <StyledPicker onValueChange={value => changeSale(value)}>
                <Picker.Item value="" label="Select" />
                {data.sales.toReversed().map(entry => (
                  <Picker.Item
                    key={entry.id}
                    value={entry.id}
                    label={entry.name}
                  />
                ))}
              </StyledPicker>
            </Settings>
          </>
        )}
        <View>
          <TabButtonContainer>
            <TabButton
              onPress={() => setCurrentTab('Active')}
              style={tabStyle(currentTab, 'Active')}
            >
              <TabLabel style={labelStyle(currentTab, 'Active')}>
                {plural(data.sale.activeBidders.length, 'Bidder')}{' Online'}
              </TabLabel>
            </TabButton>
            {/* <TabButton
              onPress={() => setCurrentTab('Sale Registered')}
              style={tabStyle(currentTab, 'Sale Registered')}
            >
              <TabLabel style={labelStyle(currentTab, 'Sale Registered')}>
                {data.sale.saleBuyerUsers.length} {'Registered for Sale'}
              </TabLabel>
            </TabButton> */}
            <TabButton
              onPress={() => setCurrentTab('Registered')}
              style={tabStyle(currentTab, 'Registered')}
            >
              <TabLabel style={labelStyle(currentTab, 'Registered')}>
                {data.sale.buyerUsers.length} {registeredLabel}
              </TabLabel>
            </TabButton>
            <TabButton
              onPress={() => setCurrentTab('Lots')}
              style={tabStyle(currentTab, 'Lots')}
            >
              <TabLabel style={labelStyle(currentTab, 'Lots')}>
                By Lot Number
              </TabLabel>
            </TabButton>
          </TabButtonContainer>
          {'Active' === currentTab && (
            <Active activeBidders={data.sale.activeBidders} />
          )}
          {/* {'Sale Registered' === currentTab && (
            <SaleRegistered
              saleId={id || sale.id}
              buyerUsers={data.sale.buyerUsers}
              saleBuyerUsers={data.sale.saleBuyerUsers}
            />
          )} */}
          {'Registered' === currentTab && (
            <Registered
              saleId={id || sale.id}
              buyerUsers={data.sale.buyerUsers}
              saleBuyerUsers={data.sale.saleBuyerUsers}
              scope={scope}
              setScope={setScope}
            />
          )}
          {'Lots' === currentTab && (
            <Lots saleId={id || sale.id} />
          )}
        </View>
      </ContentContainer>
    </MainContainer>
  );
};

export default BiddingBuyers;
